import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = { class: "gfu-layout-wrapper gfu-layout-wrapper--extranarrow gfu-4of5--l gfu-3of5--xl" }
const _hoisted_3 = ["data-qa"]
const _hoisted_4 = ["data-qa"]
const _hoisted_5 = { class: "gfu-hd gfu-hd--h3 _mb-2" }
const _hoisted_6 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_content_renderer = _resolveComponent("content-renderer")

  return (_openBlock(), _createElementBlock("div", {
    class: "gfu-project-description-section gfu-project-description-section--emphasized",
    "data-qa": `project-description-section:${$props.projectDescriptionSectionId}`
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", {
        ref: "anchor",
        class: "gfu-hd gfu-hd--h2 gfu-heading--top-divider _mb-2",
        "data-qa": `project-description-section-title:${$props.header}`
      }, _toDisplayString($props.header), 9 /* TEXT, PROPS */, _hoisted_3),
      ($props.descriptionInfo)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "gfu-project-description-section__description gfu-richtext gfu-richtext--article",
            "data-qa": `project-description-section-title:${$props.descriptionInfo.header}`
          }, [
            _createElementVNode("h3", _hoisted_5, _toDisplayString($props.descriptionInfo.header), 1 /* TEXT */),
            _createElementVNode("div", {
              innerHTML: $props.descriptionInfo.content,
              "data-qa": "stable-pledge-learn-more"
            }, null, 8 /* PROPS */, _hoisted_6)
          ], 8 /* PROPS */, _hoisted_4))
        : _createCommentVNode("v-if", true),
      ($props.content)
        ? (_openBlock(), _createBlock(_component_content_renderer, {
            key: 1,
            content: $props.content,
            class: "_mt-2"
          }, null, 8 /* PROPS */, ["content"]))
        : _createCommentVNode("v-if", true)
    ])
  ], 8 /* PROPS */, _hoisted_1))
}